export const apiURL = "https://sunway.edu.my/scholarship-api";
export const RECAPTCHA_SITE_KEY = "6LfYMaYbAAAAAJXHFkXztDY8SOBcP0cxMJSvH6Bb";

export const storagePrefix = "scholarships-client-";

export const ESSAY_MAX_CHAR = 200;
export const ESSAY_MAX_WORD = 200;
export const ADULT_AGE = "18";
export const APPLICANT_MIN_AGE = "12";
export const APPLICANT_MAX_AGE = "60";
export const ALLOWED_FILE_TYPES = " image/jpeg image/png application/pdf"; //1 character must be have space.
export const KILO_BYTES_PER_BYTE = 1024;
export const MEGA_BYTES_PER_BYTE = 1048576; 
export const MAX_ALLOWED_FILE_SIZE = 1048576 * 5; // max per file 1MB
// export const ALLOW_FILE_TYPES = " image/jpeg image/png application/pdf";
export const ALLOW_FILE_EXT = " .jpeg, .jpg, .png, .pdf";
export const MAX_FILES_PER_SUPPORT_DOC = 5;
export const ADDDITIONAL_DECLARATIONS = " ACE KPM-EN TSDSDJC 2021 AWARD ICAEW ICAEW-FULL ACCA MERIT AWAR DIP BUR BURSARY SUNWAY TES";
export const NO_ADDDITIONAL_SECTION = " EXCELLENCE ASU SUN MUSIC SPORTS YOUNG CHEF SVUMS CHANCELLOR SITI HASMA VU EX SHSM";
export const XTRACURR_W_FAMBGRD = " JCF COMMUNITY";
export const IGNORE_SUPPORT_DOC = " MUSIC_TRACK";

export const INIT_INPUT_STD_VALUES = { 
    applicant_id: '',
    frScholarship: '',
    frProgramme: '', 
    frIntake: '', 
    frName: '', 
    frICPassport: '', 
    frEmail: '', 
    frMobileNo: '', 
    frDOB: '', 
    frDateOfBirth: '', 
    frHomeAddr: '',
    frPGConsentName: '', 
    frPGConsentICPassport: '', 
    frDeclarations: false, 
    invalidMsg:'valid',
    frEssay:'',
    frVideoURL:'',
    frPortfolioURL:'',
    frExtracurricularLeadership: [{ LeaderYear: '', LeaderName: '', LeaderPosition: '' }],
    frExtracurricularCompete: [{ CompeteYear: '', CompeteName: '', CompeteResult: '' }],
    frExtracurricularAward: [{ AwardYear: '', AwardName: '' }],
    frExtracurricularOther: [{ AwardYear: '', AwardName: '' }],
    frMusic:[{ InstrumentPlayed: '', MusicGrade: '' }],    
    frSports:[{ SportLevel: '', SportType: '', SportPeriod: '', SportRemark: '' }],
    frQualification:[{highest: true, qualification: '', grade: ''}],
    frContactReferee:[{sname: '', affiliation: '', position: '', email: '' }],
    frParentGuardian:{  frCCParentChoiceOne: '', frCCParentNameOne: '', frCCParentICPasportOne: '', frParentCCAgeOne: '', frCCParentStatusOne: '', 
                        frCCParentEmployTypeOne: '', frCCParentOccupationOne: '', frCCParentWorkAddrOne: '', frCCParentIncomeOne: '', frCCParentOtherIncomeOne: '',                    
                        frCCParentChoiceTwo: '', frCCParentNameTwo: '', frCCParentICPasportTwo: '', frParentCCAgeTwo: '', frCCParentStatusTwo: '', 
                        frCCParentEmployTypeTwo: '', frCCParentOccupationTwo: '', frCCParentWorkAddrTwo: '', frCCParentIncomeTwo: '', frCCParentOtherIncomeTwo: ''},
    frSiblingStudy:[{SiblingName: '', Gender: '', Age: '', NameOfSchool: '', SrcFinSupport: '' }],
    frSiblingWorking:[{SiblingName: '', Gender: '', Age: '', Occupation: '', Income: '' }],        
    frCommunityCareInfo:{frCCHome: '', frCCAddr: '', frCCLeaderName: '', frCCPosition: '', frCCTel: '', frCCMobile: '', frCCEmail: ''}};

  export const INIT_DOCUMENTS_VALUES = {    SPM_OLEVEL_OSSC:[],
                                            SPM_OLEVEL_UEC:[],
                                            STPM_PREU_MAT_DIP_UEC:[],  
                                            SPM_STPM_PREU:[],
                                            EXAM_RESULTS:[],
                                            SPORT_CERTS:[],
                                            SPORTS_DOC:[],
                                            SPORTS_VERIF_LETT_MSN:[],
                                            SPORTS_VERIF_LETT_NHC:[],
                                            SPORT_PORTFOLIO:[],
                                            SPORTS_RECOMMEND_LETTER:[],
                                            DEGREEE_TRANSCRIPTS:[],
                                            MASTER_TRANSCRIPTS:[],
                                            MUSIC_CERTS:[],
                                            EXTRACURRICULAR_CERTS:[],
                                            PARENT_INCOME_TAX:[],
                                            PARENT_PAY_SLIP:[],
                                            PARENT_EPF:[],
                                            LEAVE_CERT_TESTIMONIALS:[],
                                            CV_ACHIEVEMENTS:[],
                                            HIGHEST_QUALIFICATION:[],
                                            HIGHEST_QUALIFICATION_INT:[],
                                            HIGHEST_QUALIFICATION_MIX:[],
                                            ART_PORTFOLIO:[],
                                            FASHION_PORTFOLIO:[],
                                            LETTER_INTENTS:[],
                                            CAREER_PORTFOLIO:[],
                                            IDENTITY_CARD:[]
                                        };